import { Typography } from "@material-ui/core"

export const StartRentMissing = ({ metaData }) => {
    return <>
        <Typography><strong>Step 1:</strong> Go to the <strong>Tenants</strong> menu.</Typography>
        <Typography><strong>Step 2:</strong> Select the tenant named <strong>{metaData?.Name}</strong>.</Typography>
        <Typography><strong>Step 2:</strong> Select the contract from sub menu on top bar.</Typography>
        <Typography><strong>Step 3:</strong> You will see add button against contract where start rent is missing, click on add button to add start rent details.</Typography>
    </>
}